module.exports = __webpack_public_path__ + "static/adega-pegos-claros-9ffdcc56b72c188cda9d9f5f837fd3de.png";